import React from 'react';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import { useExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { ExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types/src/application.tsx';
import { ExperienceTrackersNames } from '../../../common/constants.tsx';

const ANALYTICS_SOURCE = 'agentPickerBulk';

export const useAgentPickerBulkOpenMenuExpStart = () => {
	return useExperienceStart({
		experience: ExperienceTrackersNames.AGENT_PICKER_DROPDOWN_TRIGGER_BACKLOG_BULK_ISSUES_OPEN_MENU,
		experienceId: `${Date.now()}`,
		analyticsSource: ANALYTICS_SOURCE,
		application: JIRA_SOFTWARE,
	});
};

export const useAgentPickerBulkOpenMenuExpFail = () =>
	useExperienceFail({
		experience: ExperienceTrackersNames.AGENT_PICKER_DROPDOWN_TRIGGER_BACKLOG_BULK_ISSUES_OPEN_MENU,
	});

export const AgentPickerBulkOpenMenuExpSuccess = () => (
	<ExperienceSuccess
		experience={ExperienceTrackersNames.AGENT_PICKER_DROPDOWN_TRIGGER_BACKLOG_BULK_ISSUES_OPEN_MENU}
	/>
);
export const useAgentPickerSingleIssueOpenMenuExpStart = () => {
	return useExperienceStart({
		experience: ExperienceTrackersNames.AGENT_PICKER_DROPDOWN_TRIGGER_SINGLE_ISSUE_OPEN_MENU,
		experienceId: `${Date.now()}`,
		analyticsSource: ANALYTICS_SOURCE,
		application: JIRA_SOFTWARE,
	});
};

export const useAgentPickerSingleIssueOpenMenuExpFail = () =>
	useExperienceFail({
		experience: ExperienceTrackersNames.AGENT_PICKER_DROPDOWN_TRIGGER_SINGLE_ISSUE_OPEN_MENU,
	});

export const AgentPickerSingleIssueOpenMenuExpSuccess = () => (
	<ExperienceSuccess
		experience={ExperienceTrackersNames.AGENT_PICKER_DROPDOWN_TRIGGER_SINGLE_ISSUE_OPEN_MENU}
	/>
);
